import { render, staticRenderFns } from "./ProjectSettingsProjectType.vue?vue&type=template&id=60c66e20&scoped=true"
import script from "./ProjectSettingsProjectType.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsProjectType.vue?vue&type=script&lang=js"
import style0 from "./ProjectSettingsProjectType.vue?vue&type=style&index=0&id=60c66e20&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c66e20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c66e20')) {
      api.createRecord('60c66e20', component.options)
    } else {
      api.reload('60c66e20', component.options)
    }
    module.hot.accept("./ProjectSettingsProjectType.vue?vue&type=template&id=60c66e20&scoped=true", function () {
      api.rerender('60c66e20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/projects/ProjectSettingsProjectType.vue"
export default component.exports